import axios from "../index";

const search = (query) => {
  return axios.get(`search?type=${query.type}&document=${query.document}&value=${query.value}`);
}

const checkPersonal = (query) => {
  return axios.get(`check-personal?type=${query.type}&document=${query.document}&value=${query.value}`)
}

const checkCollective = (query) => {
  return axios.get(`check-collective?type=${query.type}&document=${query.document}&value=${query.value}`)
}

const getTimePlacePersonal = params => {
  return axios.get('time-place-personal', { params })
}
const getTimePlaceCollective = params => {
  return axios.get('time-place-collective', { params })
}

const checkPersonalResult = (params) => axios.get(`check-personal-result`, { params })

const checkCollectiveResult = (params) => axios.get(`check-collective-result`, { params })

export default { search, getTimePlacePersonal, checkPersonal, checkCollective, getTimePlaceCollective, checkPersonalResult, checkCollectiveResult }